import { CCUS05Handler } from "../handler/HandlerImpl";
import { ColumnsType } from "antd/es/table";
import { DataTableType } from "../../entity/Entity";
import SortTable from "../../../../../common/components/sort-table/SortTable";
import { Tooltip } from "antd";
import MESSAGE from "../../../../../common/constants/MESSAGE";

export const COLUMN = (handler: CCUS05Handler) => {
  const sortType = handler.sortType
  const sortBy = handler.sortBy

  const columnsTable: ColumnsType<DataTableType> = [
    {
      title: (
        <SortTable
          columnTitle="案件名"
          sortOrder={handler.funcCheckSortOrder("project", sortType, sortBy)}
          onChange={(sortOrder) => handler.funcSortTable("project", sortOrder)}
          justifyContent="start"
        />
      ),
      dataIndex: "project",
      render: (text) => <div className="text-table-ccus">{text}</div>,
      width: 130,
    },
    {
      title: (
        <SortTable
          columnTitle="所属事業者名"
          sortOrder={handler.funcCheckSortOrder("company", sortType, sortBy)}
          onChange={(sortOrder) => handler.funcSortTable("company", sortOrder)}
          justifyContent="start"
        />
      ),
      dataIndex: "company",
      render: (text) => <div className="text-table-ccus">{text}</div>,
      width: 140,
    },
    {
      title: (
        <SortTable
          columnTitle="技能者名"
          sortOrder={handler.funcCheckSortOrder("user", sortType, sortBy)}
          onChange={(sortOrder) => handler.funcSortTable("user", sortOrder)}
          justifyContent="start"
        />
      ),
      dataIndex: "user",
      render: (text) => <div className="text-table-ccus">{text}</div>,
      width: 135,
    },
    {
      title: (
        <SortTable
          columnTitle="対象日"
          sortOrder={handler.funcCheckSortOrder(
            "attendanceDate",
            sortType,
            sortBy
          )}
          onChange={(sortOrder) =>
            handler.funcSortTable("attendanceDate", sortOrder)
          }
          justifyContent="start"
        />
      ),
      dataIndex: "attendanceDate",
      render: (text) => <div className="text-table-ccus">{text}</div>,
      width: 120,
    },
    {
      title: (
        <SortTable
          columnTitle="出勤時間"
          sortOrder={handler.funcCheckSortOrder("checkin", sortType, sortBy)}
          onChange={(sortOrder) => handler.funcSortTable("checkin", sortOrder)}
          justifyContent="start"
        />
      ),
      dataIndex: "checkin",
      render: (text) => <div className="text-table-ccus">{text}</div>,
      width: 110,
    },
    {
      title: (
        <SortTable
          columnTitle="退勤時間"
          sortOrder={handler.funcCheckSortOrder("checkout", sortType, sortBy)}
          onChange={(sortOrder) => handler.funcSortTable("checkout", sortOrder)}
          justifyContent="start"
        />
      ),
      dataIndex: "checkout",
      render: (text) => <div className="text-table-ccus">{text}</div>,
      width: 110,
    },
    {
      title: (
        <SortTable
          columnTitle="登録区分"
          sortOrder={handler.funcCheckSortOrder(
            "registerType",
            sortType,
            sortBy
          )}
          onChange={(sortOrder) =>
            handler.funcSortTable("registerType", sortOrder)
          }
          justifyContent="start"
        />
      ),
      width: 120,
      dataIndex: "registerType",
      render: (text) => <div className="text-table-ccus">{text}</div>,
    },
  ];

  const rowSelection = {
    selectedRowKeys: handler.selectedRowsKey,
    onChange: (selectedRowKeys: React.Key[]) => {
      handler.getSelectedKey(selectedRowKeys);
    },
    // Bản ghi chưa xác thực CCUS vẫn hiển thị nhưng không cho chọn.
    // antd cũng tự loại các dòng disabled ra khỏi thao tác chọn tất cả.
    getCheckboxProps: (record: DataTableType) => ({
      disabled: record.isCcusVerified === false,
    }),
    // Checkbox disabled không tự bắn sự kiện chuột, nên bọc thêm 1 lớp span
    // để Tooltip nhận được hover.
    renderCell: (
      _checked: boolean,
      record: DataTableType,
      _index: number,
      originNode: React.ReactNode
    ) =>
      record.isCcusVerified === false ? (
        <Tooltip title={MESSAGE.MESSAGE_CCUS05_NOT_VERIFIED}>
          <span style={{ display: "inline-block" }}>{originNode}</span>
        </Tooltip>
      ) : (
        originNode
      ),
  };
  return {
    columnsTable,
    rowSelection,
  };
};
